<template>
  <section class="timeTplListDetail p-4">
    <section>
      <viewTitle
        title="业务管理 / 预约时间模板 / 查看模板详情"
        :showReturn="true"
      />
    </section>

    <div class="main">
      <el-form label-width="140px" label-position="left">
        <el-form-item label="模板名称">
          {{ timeTpObj.name || "--" }}
        </el-form-item>
        <el-form-item label="有效时间范围">
          <span v-if="Number(timeTpObj.timeType) == 1"> 永久有效</span>
          <span v-if="Number(timeTpObj.timeType) == 2">
            {{ formatBookingTime(timeTpObj.timeRang[0]) }} ~
            {{ formatBookingTime(timeTpObj.timeRang[1]) }}</span
          >
        </el-form-item>
        <!-- <el-form-item label="法定节假日">
          <span v-if="Number(timeTpObj.holidayType) == 2"> 不使用</span>
          <span v-if="Number(timeTpObj.holidayType) == 1">
            自动根据法定节假日修正
          </span>
        </el-form-item> -->
        <el-form-item label="排除所选日期">
          <div class="">
            <template>
              <el-tag v-for="tag in timeTpObj.delDay" :key="tag">
                {{ tag }}
              </el-tag>
              <span v-if="timeTpObj.delDay.length === 0">--</span>
            </template>
          </div>
        </el-form-item>
        <el-form-item label="添加额外日期">
          <div class="">
            <template>
              <el-tag v-for="tag in timeTpObj.addDay" :key="tag">
                {{ tag }}
              </el-tag>
              <span v-if="timeTpObj.addDay.length === 0">--</span>
            </template>
          </div>
        </el-form-item>
        <el-form-item label="重复设置">
          <div v-if="timeTpObj.checkList.length === 7">
            每天
          </div>
          <div v-else>
            <span v-for="(index, ids) in timeTpObj.checkList" :key="index">
              <span v-if="Number(index) == 1">周一</span>
              <span v-if="Number(index) == 2">周二</span>
              <span v-if="Number(index) == 3">周三</span>
              <span v-if="Number(index) == 4">周四</span>
              <span v-if="Number(index) == 5">周五</span>
              <span v-if="Number(index) == 6">周六</span>
              <span v-if="Number(index) == 0">周日</span>
              <span v-if="ids !== timeTpObj.checkList.length - 1">、</span>
            </span>
          </div>
        </el-form-item>
        <el-form-item label="每日号源划分">
          <div class="">
            <div class="sourceResult">
              <template v-for="(item, index) in timeTpObj.daySource">
                <div :key="index" type="info">
                  <div v-for="(group, index) in item.group_number" :key="index">
                    <span :style="{ opacity: index == 0 ? 1 : 0 }">[ {{ item.begin_time }} ~ {{ item.end_time }} ] </span>
                    <span>{{ getGrouoName(group.group_id) }}</span>
                    <span>（{{ Number(group.number) == 0 ? "不限" : group.number }}）</span>
                    <template v-if="!Array.isArray(group.detail)">
                      <span style="display: block" v-for="(car, ind) in getGrouoItem(group.group_id).sub_business_list" :key="car.id">
                        <span style="opacity: 0;user-select: none;">[ {{ item.begin_time }} ~ {{ item.end_time }} ] </span>
                        <span>{{ car.name }}：{{ !group.detail[car.id] || group.detail[car.id] == -1 ? '不限' : group.detail[car.id] }}</span>
                      </span>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="最小可预约时间">
          <span v-if="dataArr.min_booking_time > 0">
            {{ formatMin(timeTpObj.minRangKey) || "--" }}</span
          >
          <span v-else>无限制</span>
        </el-form-item>
        <el-form-item label="最大可预约时间">
          <span>{{ maxRangKeyDesc || "--" }}</span>
        </el-form-item>
        <el-form-item label="备注">
          <span>{{ timeTpObj.textarea || "--" }}</span>
        </el-form-item>
        <el-form-item label="排队登记可延迟时间">
          <span>{{ timeTpObj.check_effectivity_time || "--" }}{{ timeTpObj.check_effectivity_time ? '小时' : '' }}</span>
        </el-form-item>
        <el-form-item label="叫号后过期时间">
          <span>{{ timeTpObj.calling_effectivity_time || "--" }}{{ timeTpObj.calling_effectivity_time ? '分钟' : '' }}</span>
        </el-form-item>
        <el-form-item label="生效时间">
          <span v-if="Number(timeTpObj.valid_state) == 1" class="color67"
            >未生效</span
          >
          <span v-else-if="Number(timeTpObj.valid_state) == 2" class="color5E"
            >生效中</span
          >
          <span v-else-if="Number(timeTpObj.valid_state) == 3" class="color99"
            >已失效</span
          >
          <span v-else>--</span>
        </el-form-item>
        <el-form-item label="模板状态">
          <span v-if="Number(timeTpObj.state) == 1" class="color5E">正常</span>
          <span v-else-if="Number(timeTpObj.state) == 2" class="color67"
            >禁用</span
          >
          <span v-else>--</span>
        </el-form-item>
        <el-form-item label="使用中实例个数">
          {{ timeTpObj.used_instance_num }}个
        </el-form-item>
        <el-form-item label="有效实例个数">
          {{ timeTpObj.instance_num }}个
        </el-form-item>
        <el-form-item label="历史版本">
          {{ timeTpObj.history_num }}个
        </el-form-item>
        <el-form-item label="创建日期">
          {{ timeTpObj.create_time }}
        </el-form-item>
        <el-form-item label="最后更新日期">
          {{ timeTpObj.update_time }}
        </el-form-item>
      </el-form>
      <div style="margin: 30px 0px 11px;">
        <el-button v-has="['c-base-mp-mtime-update']" type="primary" @click="editTimeTp" size="small">
          编 辑
        </el-button>
        <el-button
          type="warning"
          size="small"
          style="color: white;"
          v-has="['c-base-mp-mtime-switch']"
          @click="disableTimeTp"
          >{{ Number(timeTpObj.state) == 1 ? "禁 用" : "启 用" }}</el-button
        >
        <el-button
          type="danger"
          style="color: #fff;"
          v-has="['c-base-mp-mtime-delete']"
          @click="delTimeTp"
          size="small"
        >
          删 除
        </el-button>
        <!-- <el-button @click="backList">返回</el-button> -->
      </div>
    </div>
  </section>
</template>
<script>
import viewTitle from "@/components/viewTitle";
import confirm from "@/components/elementPlus/packages/confirm";
import moment from "moment";
export default {
  props: {},
  data() {
    return {
      carTypes: [
        { name: "平板车", key: "flatTruck" },
        { name: "货柜车", key: "containerTruck" },
        { name: "槽罐车", key: "tankTruck" },
        { name: "高栏车", key: "highSidedTruck" },
        { name: "其他", key: "orderTruck" }
      ],
      timeTpObj: {
        name: "",
        timeType: "",
        timeRang: [],
        delDay: [],
        addDay: [],
        checkList: [],
        minRangList: [
          {
            value: "0",
            label: "0分钟 无时间限制"
          },
          {
            value: "1800",
            label: "不小于30分钟"
          },
          {
            value: "3600",
            label: "不小于1小时(推荐)"
          },
          {
            value: "7200",
            label: "不小于2小时"
          },
          {
            value: "10800",
            label: "不小于3小时"
          },
          {
            value: "14400",
            label: "不小于4小时"
          },
          {
            value: "18000",
            label: "不小于5小时"
          }
        ],
        maxRangList: [
          {
            value: "1",
            label: "1天内"
          },
          {
            value: "2",
            label: "2天内"
          },
          {
            value: "3",
            label: "3天内"
          },
          {
            value: "7",
            label: "7天内(推荐)"
          },
          {
            value: "15",
            label: "15天内"
          },
          {
            value: "30",
            label: "30天内"
          }
        ],
        options: [],
        textarea: "",
        minRangKey: "",
        maxRangKey: "",
        daySource: []
      },
      businessList: [],
      dataArr: {}
    };
  },
  watch: {},
  components: { viewTitle },
  computed: {
    getGrouoName() {
      return id => {
        for (let i = 0; i < this.businessList.length; i++) {
          let item = this.businessList[i];
          if (id == item.id) {
            return item.name;
          }
        }
      };
    },
    getGrouoItem() {
      return id => {
        for (let i = 0; i < this.businessList.length; i++) {
          let item = this.businessList[i];
          if (id == item.id) {
            return item;
          }
        }
      };
    },
    minRangKeyDesc() {
      let text = "";
      this.timeTpObj.minRangList.forEach(item => {
        if (Number(this.timeTpObj.minRangKey) == Number(item.value)) {
          text = item.label;
        }
      });
      return text;
    },
    maxRangKeyDesc() {
      let text = "";
      this.timeTpObj.maxRangList.forEach(item => {
        if (Number(this.timeTpObj.maxRangKey) == Number(item.value)) {
          text = item.label;
        }
      });
      return text;
    }
  },
  methods: {
    // 格式化时间
    formatBookingTime(str) {
      let str1 = String(str);
      if (moment().year() === Number(str1.substring(0, 4))) {
        return `${str1.substring(4, 6)}月${str1.substring(6, 8)}日`;
      } else {
        return `${str1.substring(0, 4)}年
          ${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日`;
      }
    },

    // 格式化创建时间
    formatCreateTime(str) {
      let str1 = str.split("-");
      if (moment().year() === Number(str1[0])) {
        return `${str1[1]}月${str1[2]}日`;
      } else {
        return `${str1[0]}年
          ${str1[1]}月
          ${str1[2]}日`;
      }
    },

    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    editTimeTp() {
      this.$router.push({
        path:
          "/rhqy/service/appoint/timeTplList/addAndEdit/" + this.timeTpObj.id
      });
    },
    disableTimeTp() {
      confirm({
        title: "确认提示",
        message:
          Number(this.timeTpObj.state) == 1
            ? `确认要禁用“<span class="color67">${this.timeTpObj.name}</span>”吗？<br />
        禁用后未被使用的模板实例也将被删除！`
            : `确认要启用“<span class="color67">${this.timeTpObj.name}</span>”吗？<br />
        禁用后未被使用的模板实例也将被删除！`,
        confirmAc: () => {
          this.$common
            .http({
              url: "/api/queue/admin/enable_business_time_model",
              data: {
                id: this.timeTpObj.id
              }
            })
            .then(() => {
              this.getInitData(this.$route.params.id);
            });
        },
        confirmAcClass: "btnConfirmPrimary",
        cancelAcClass: "btnCancel"
      });
    },
    delTimeTp() {
      confirm({
        title: "确认提示",
        message: `确认要删除“<span class="color67">${this.timeTpObj.name}</span>”吗？<br />
        未被使用的模板实例也将被一并删除！<br />
        <span class="color67">删除后不可恢复！</span>`,
        confirmAc: () => {
          this.$common
            .http({
              url: "/api/queue/admin/delete_business_time_model",
              data: {
                id: this.timeTpObj.id
              }
            })
            .then(() => {
              this.$common.pcToastSuccess("删除成功");
              this.backList();
            });
        },
        confirmAcClass: "btnConfirmDanger",
        cancelAcClass: "btnCancel"
      });
    },
    backList() {
      this.$router.go(-1);
    },
    getInitData(id) {
      this.$common
        .http({
          url: "/api/queue/admin/query_business_time_model_detail",
          data: {
            id
          }
        })
        .then(res => {
          console.log(res.data.data);
          const data = res.data.data;
          this.dataArr = data;
          this.timeTpObj.id = data.id;
          this.timeTpObj.name = data.name;
          this.timeTpObj.timeType = data.is_permanent_valid.toString();
          if (data.is_permanent_valid.toString() == "2") {
            this.timeTpObj.timeRang = [
              data.begin_time.toString(),
              data.end_time.toString()
            ];
          } else {
            this.timeTpObj.timeRang = [];
          }
          this.timeTpObj.holidayType = data.is_use_statutory_holidays.toString();
          this.timeTpObj.addDay = data.exclude_day;
          this.timeTpObj.delDay = data.extra_day;
          this.timeTpObj.checkList = data.repeat_setting;
          this.timeTpObj.minRangKey = data.min_booking_time.toString();
          this.timeTpObj.maxRangKey = data.max_booking_day.toString();
          this.timeTpObj.textarea = data.note;
          this.timeTpObj.check_effectivity_time = data.check_effectivity_time;
          this.timeTpObj.calling_effectivity_time = data.calling_effectivity_time;
          this.timeTpObj.daySource = data.periods;
          this.timeTpObj.create_time = this.formatTime(data.create_time);
          this.timeTpObj.update_time = this.formatTime(data.update_time);
          this.timeTpObj.valid_state = data.valid_state;
          this.timeTpObj.state = data.state;
          this.timeTpObj.used_instance_num = data.used_instance_num;
          this.timeTpObj.instance_num = data.instance_num;
          this.timeTpObj.history_num = data.history_num;
        });
    },
    getBusinessList() {
      this.$common
        .http({
          url: "/api/queue/admin/query_business_group",
          data: {
            keyword: "",
            state: 1,
            page_size: 1000
          }
        })
        .then(res => {
          this.businessList = res.data.data.data;
        });
    },
    saveTmp() {
      let data = {
        id: this.$route.params.id || "",
        name: this.timeTpObj.name,
        is_permanent_valid: Number(this.timeTpObj.timeType),
        begin_time: this.timeTpObj.timeRang[0] || "",
        end_time: this.timeTpObj.timeRang[1] || "",
        is_use_statutory_holidays: Number(this.timeTpObj.holidayType),
        exclude_day: JSON.stringify(this.timeTpObj.addDay),
        extra_day: JSON.stringify(this.timeTpObj.delDay),
        repeat_setting: JSON.stringify(this.timeTpObj.checkList),
        min_booking_time: this.timeTpObj.minRangKey,
        max_booking_day: this.timeTpObj.maxRangKey,
        note: this.timeTpObj.textarea,
        period_number: JSON.stringify(this.timeTpObj.daySource)
      };
      this.$common
        .http({
          url: "/api/queue/admin/save_business_time_model",
          data: data
        })
        .then(() => {
          if (this.$route.params.id) {
            this.$common.pcToastSuccess("修改成功");
          } else {
            this.$common.pcToastSuccess("创建成功");
          }
          this.$router.go(-1);
        });
    },
    // 格式化最小可预约时间
    formatMin(str) {
      if (str === 0) {
        return `无限制`;
      } else {
        return `不小于${parseFloat((str / 60 / 60).toFixed(2))}小时`;
      }
    }
  },
  created() {
    this.getBusinessList();
    if (this.$route.params.id) {
      this.getInitData(this.$route.params.id);
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.timeTplListDetail {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  .main {
    padding: 5px 16px;
    .el-row {
      padding-bottom: 18px;
    }
    .el-col-4 {
      text-align: right;
    }
    .elRadio1 {
      width: 70px;
    }
    .el-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .addDay {
      color: #409eff;
      font-size: 20px;
      cursor: pointer;
    }
    .c4b {
      padding: 5px 10px 0px 10px;
      border: 1px solid #cecece;
    }
    .full100 {
      display: flex;
      align-items: center;
      .w100 {
        width: 100%;
      }
    }
    .dayDiv {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .el-select {
      width: 100%;
    }
    .sourceResult {
      .desc {
        display: inline-block;
        padding-bottom: 5px;
      }
      .el-tag {
        display: inline-block;
        white-space: normal;
        height: auto;
        line-height: 17px;
        padding: 5px 28px 5px 8px;
        position: relative;
        width: 100%;
      }
    }
  }
  .elDialog {
    .el-row {
      padding-bottom: 18px;
    }
    .divRow {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .el-radio {
        margin-right: 10px;
      }
      .el-select {
        width: 200px;
        margin-right: 10px;
      }
      .el-input {
        width: 100px;
        margin-right: 10px;
      }
    }
    .el-col-4 {
      text-align: right;
    }
    .plus {
      color: #409eff;
      cursor: pointer;
    }
    .close {
      color: coral;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less">
.timeTplListDetail {
  .el-date-editor .el-range-separator {
    line-height: 24px;
  }
  .sourceResult {
    .el-tag {
      .el-icon-close {
        right: 8px;
        top: 50%;
        transform: translate(0, -50%);
        position: absolute;
      }
    }
  }
  .delDayTimePlugin,
  .addDayTimePlugin {
    width: 0;
    opacity: 0;
    > input {
      border: 0 !important;
      padding: 0;
    }
  }
  .el-form-item {
    margin-bottom: 0px;
  }
}
</style>
